// Puerto verbatim de packages/hce/src/hce/paciente/GrupoFormularioTab.tsx.
import type { JSX } from 'react';
import { useParams } from 'react-router';
import { SelectorFormularios } from './SelectorFormularios';

export interface GrupoFormularioTabProps {
  readonly grupo: string;
}

export function GrupoFormularioTab({ grupo }: GrupoFormularioTabProps): JSX.Element {
  const { id } = useParams() as { id: string };
  return <SelectorFormularios subject={`Patient/${id}`} soloGrupo={grupo} />;
}
